import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.from";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

import _each from "lodash/each";
import googleConversion from "web/script/embedded/google-conversion";
import environment from "web/script/modules/environment";
export default {
  // Search related conversion actions
  conversionIdSearch: 982977399,
  rplConversionLabel: "p9nCCMudtNMBEPeW3NQD",
  appBannerConversionLabel: "qaESCNf5zdUBEPeW3NQD",
  // CSS related conversion actions
  conversionIdsCSS: {
    "lyst.co.uk": 827715413,
    "lyst.de": 788956605,
    "lystapp.be": 788956605,
    "lyst.at": 788956605,
    "lyst.ch": 788956605,
    "lyst.com.nl": 788956605,
    "lyst.fr": 807037325,
    "lyst.es": 801694380,
    "lyst.it": 783391789,
    "lyst.com": 778294182
  },
  conversionLabelsCSS: {
    "lyst.co.uk": "pWPzCOCzvMoBENXe14oD",
    "lyst.de": "nHS1CL_u08oBEL2LmvgC",
    "lystapp.be": "nHS1CL_u08oBEL2LmvgC",
    "lyst.at": "nHS1CL_u08oBEL2LmvgC",
    "lyst.ch": "nHS1CL_u08oBEL2LmvgC",
    "lyst.com.nl": "nHS1CL_u08oBEL2LmvgC",
    "lyst.fr": "dloZCI3q4soBEI3T6YAD",
    "lyst.es": "ekuVCI-X78oBEKzFo_4C",
    "lyst.it": "SPcvCIPu08oBEK24xvUC",
    "lyst.com": "2YOKCK_hhssBEKanj_MC"
  },
  conversionCurrenciesCSS: {
    "lyst.co.uk": "GBP",
    "lyst.de": "EUR",
    "lystapp.be": "EUR",
    "lyst.at": "EUR",
    "lyst.ch": "EUR",
    "lyst.com.nl": "EUR",
    "lyst.fr": "EUR",
    "lyst.es": "EUR",
    "lyst.it": "EUR",
    "lyst.com": "EUR"
  },
  domain: null,
  init: function init(analytics) {
    googleConversion("config", "AW-" + this.conversionIdSearch, {
      send_page_view: false
    });

    var domain = analytics._getCookieDomain();

    if (domain in this.conversionIdsCSS) {
      googleConversion("config", "AW-" + this.conversionIdsCSS[domain], {
        send_page_view: false
      });
      this.domain = domain;
    }
  },
  send: function send(data) {
    var _this = this;

    // this will contain any promises we generate
    var promises = [];

    _each(data, function (event) {
      if (event.type === "page_view") {
        var adwordsPayload = {
          google_remarketing_only: true
        };

        if (event.data.product_id) {
          adwordsPayload.ecomm_prodid = event.data.product_id;
          adwordsPayload.ecomm_pagetype = "product";
        }

        if (event.data.paid_no_retarget) {
          adwordsPayload.no_retarget = event.data.paid_no_retarget;
        }

        if (event.data.life_cycle_stage) {
          adwordsPayload.life_cycle_stage = event.data.life_cycle_stage;
        } // Send to default group - all accounts


        googleConversion("event", "page_view", adwordsPayload);
      } else if (event.type === "event" && event.data.category === "affiliate" && (event.data.action === "lead" || event.data.action === "lead_sold_out")) {
        // CSS conversion pixel
        var averageRPC = environment.get("averageRPC");

        if (event.data.customData && event.data.customData.isCssLead && _this.domain in _this.conversionIdsCSS && averageRPC) {
          promises.push(createConversionGtagPromise(_this.conversionIdsCSS[_this.domain], _this.conversionLabelsCSS[_this.domain], averageRPC, _this.conversionCurrenciesCSS[_this.domain]));
        } // Remarketing pixel, send to default group - all accounts


        promises.push(createGtagPromise("page_view", {
          value: 0
        })); // Revenue-per-Lead predicted conversion value

        var predictedRPL = environment.get("predictedTrackValue");

        if (predictedRPL) {
          promises.push(createConversionGtagPromise(_this.conversionIdSearch, _this.rplConversionLabel, predictedRPL, "USD"));
        }
      } else if (event.type === "event" && event.data.category === "web_to_app" && event.data.action === "click") {
        var campaignName = event.data.customData["campaign_name"];
        var cpi = environment.get("webToAppCpi", {})[campaignName];
        promises.push(createConversionGtagPromise.apply(void 0, [_this.conversionIdSearch, _this.appBannerConversionLabel].concat(_toConsumableArray(cpi === undefined ? [] : [cpi, "USD"]))));
      }
    }); // wait for any promises what we were asked to wait for


    return Promise.all(promises);
  }
};

function createGtagPromise(event, data) {
  return new Promise(function (resolve) {
    // create gtag
    data.event_callback = resolve;
    googleConversion("event", event, data);
  });
}

function createConversionGtagPromise(id, label, value, currency) {
  var data = {
    send_to: "AW-" + id + "/" + label,
    label: label
  };

  if (value || value === 0) {
    data.value = value;
  }

  if (currency) {
    data.currency = currency;
  }

  return createGtagPromise("conversion", data);
}